module.exports = __webpack_public_path__ + "static/media/ds.52de795c.png";